<template>
  <div class="d-flex flex-column row-gap-3" data-locator="notifications-history">
    <div class="heading-sm-bold text-text-primary">
      {{ $t('project.project-settings.ProjectSettingsNotifications.title') }}
    </div>

      <ProjectSettingsNotificationsTopBar class="mb-4" :mnemo="mnemo"/>

    <AppCard>
      <ProjectSettingsNotificationsTable :mnemo="mnemo" />
    </AppCard>
  </div>
</template>

<script>
  import AppCard from '@/common/AppCard.vue'

  import ProjectSettingsNotificationsTable from './ProjectSettingsNotificationsTable.vue'
  import ProjectSettingsNotificationsTopBar from './ProjectSettingsNotificationsTopBar.vue'

  export default {
    name: 'ProjectSettingsNotifications',
    components: {
      AppCard,
      ProjectSettingsNotificationsTable,
      ProjectSettingsNotificationsTopBar,
    },
    props: {
      mnemo: {
        type: String,
        required: true,
      },
    },
  }
</script>
